import xhrService from '../xhrService';


const saveGuestToken = (token) =>
  sessionStorage.setItem('guestToken', JSON.stringify(token));

export const userApi = {
  index: (context = null, pageNumber = null, searchQuery = null) => {
    const params = {};

    if (context) {
      params.context = context;
    }

    if (searchQuery) {
      params.s = searchQuery;
    }

    if (pageNumber) {
      params.p = pageNumber;
    }

    return xhrService.get('/api/users').then((res) => res.data);
  },
  tenantInfo: () => {
    return xhrService.get(`/api/users/tenantInfo`).then((res) => res.data);
  },
  tenantInfoInspection: () => {
    return xhrService
      .get(`/api/users/tenantInfoInspection`)
      .then((res) => res.data);
  },
  tenantUpdate: (data) =>
    xhrService
      .post('/api/users/tenantUpdate', data)
      .then((res) => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      }),
  tenantUpdateInspection: (data) =>
    xhrService
      .post('/api/users/tenantUpdateInspection', data)
      .then((res) => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      }),
  create: (data) =>
    xhrService
      .post('/api/users', data)
      .then((res) => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      }),
  getTenantsAndNotifs: (userId) => {
    return xhrService
      .get(`/api/users/${userId}/getTenantsAndNotifs`)
      .then((res) => res.data);
  },
  getUserByTenant: (userId, tenantId) => {
    return xhrService
      .get(`/api/users/${userId}/tenant/${tenantId}`)
      .then((res) => res.data);
  },
  getProfile: (id) => {
    return xhrService.get(`/api/users/profile/${id}`).then((res) => res.data);
  },
  getCreateOpts: (data) => {
    return xhrService
      .get(`/api/users/groups/creation`, { params: data })
      .then((res) => res.data);
  },
  getUsersByRole:(data)=> {
    return xhrService.get(`/api/users/getUsersByRole`,{params:data}).then((res) => res.data);
  },
  getManagees:(data)=> {
    return xhrService.get(`/api/users/getManagees`,{params:data}).then((res) => res.data);
  },
  fetchUserClientProjects: (userId, tenantId, page, search = null, newClients = [], oldClients = []) => {
    return xhrService
      .get(`/api/users/${userId}/tenant/${tenantId}/getUserClientProjects`, {
        params: {
          page,
          search,
          newClients,
          oldClients,
        },
      })
      .then((res) => res.data);
  },
  isLoggedIn:(data) => {
    // Check if user is logged in by verifying presence of HTTP-only cookie
    return xhrService.get('/api/users/isLoggedIn', {
      params: data,
    })
    .then((res) => res.data.isLoggedIn)
    .catch(() => false);
  },
  login: (email, password, tenant) =>
    xhrService
      .post('/api/login', { email, password, tenant })
      .then(({ data }) => {
        return true;
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      }),
  verifyUser: (email, password) =>
    xhrService
      .post('/api/verifyUser', { email, password },
        {
          withCredentials: true,
        }
      )
      .then(({ data }) => {
        if (data) {
          return data;
        }
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      }),
  getTenantByName: (tenant) =>{
    if (/^(login|trial)/.test(tenant)) {
      return Promise.reject(null);
    }

    return xhrService
      .get(`/api/getTenantByName/${tenant}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => res.data)
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      });
    },
  changeTenant: (tenant) =>
    xhrService
      .post('/api/tenants/changeTenant', { tenantId: tenant },
        {
          withCredentials: true,
        }
      )
      .then((res) => res.data)
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      }),
  redirectTenant: (tenant) =>
    xhrService
      .post('/api/tenants/redirectTenant', { tenantId: tenant },
        {
          withCredentials: true,
        }
      )
      .then((res) => res.data)
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      }),

  publiclogin: (email, password, tenant, publicUserData) => 
    xhrService
      .post('/api/login', { email, password, tenant, loginType:'other', publicUserData })
      .then(({ data }) => {
        return true;
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      }),
  publicLoginWithProject: (email, password, projectId, publicUserData) => 
    xhrService
      .post('/api/login', { email, password, projectId, loginType:'other', publicUserData })
       .then(({ data }) => {
        return true;
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      }),
  guestlogin: (email, password, tenant) =>
    xhrService
      .post('/api/login', { email, password, tenant, loginType:'other' })
      .then(({ data }) => {
        return true;
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      }),
  logout: () => {
    // Clear HTTP-only cookie by calling logout endpoint
    return xhrService
      .post('/api/logout', {})
      .then(() => {
        // Clear other localStorage items (not token-related)
        localStorage.removeItem('divisionId');
        localStorage.removeItem('Qr Access');
        localStorage.removeItem('navigationPanel');
      })
      .catch(() => {
        // Clear localStorage items even if logout fails
        localStorage.removeItem('divisionId');
        localStorage.removeItem('Qr Access');
        localStorage.removeItem('navigationPanel');
      });
  },
  resetPassword: (token, form) => {
    return xhrService
      .post(`/api/resetPassword`, { token, ...form })
      .then(({ data }) => {
        return true;
      }).catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      });
  },
  forgotPassword: (email) => {
    return xhrService
      .post('/api/forgotPassword', email,
         {
          withCredentials: true,
        }
      )
      .then((res) => res.data);
  },
  register: (token, form) => {
    return xhrService
      .post(`/api/register`, {
        token,
        ...form,
      })
      .then((res) => res.data)
      .then(({ data }) => {
        return true;
      }).catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      });
  },

  /** Get the profile of logged in user */
  profile: async () => {
    if (await userApi.isLoggedIn()) {
      return xhrService
        .get('/api/users/profile')
        .then((res) => res.data)
        .catch(() => {
          // invalid or deprecated token - HTTP-only cookie will be cleared by server
          return Promise.reject(null);
        });
    }

    return Promise.reject('User is not logged in');
  },
  update: (id, data) =>
    xhrService.post(`/api/users/update/${id}`, data).then((res) => res.data),
  addTenant: (data) =>
    xhrService
      .post(`/api/users/${data.userId}/addTenant`, data)
      .then((res) => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      }),

  updateProfile: (data) =>
    xhrService.post(`/api/users/profile`, data).then((res) => res.data),

  /**
   * Validate a user
   */
  validate: (token) =>
    xhrService.post(`/api/user/validate`, { token }).then((res) => res.data),

  /**
   * On confirm, resend user invitation
   */
  invite: (id) =>
    xhrService.post(`/api/users/${id}/invite`).then((res) => res.data),

  toggleActivation: (id) =>
    xhrService.put(`/api/users/${id}/status`).then((res) => res.data),

  updateElectronicSignatureAuthorization: (id, action) =>
    xhrService
      .post(`/api/users/${id}/signature_authorization/${action}`)
      .then((res) => res.data),

  getProjectList: (id) =>
    xhrService.get(`/api/users/${id}/projectList`).then((res) => res.data),

  getProjectListTenantWise: (id, tenantId) =>
    xhrService
      .get(`/api/users/${id}/projectListTenantWise/${tenantId}`)
      .then((res) => res.data),

  getUserSignature: () => {
    return xhrService
      .get(`/api/users/profile/getSignature`)
      .then((response) => response.data)
      .catch((e) => {
        return Promise.reject(false);
      });
  },

  getUserSignatureId: (id, date) => {
    return xhrService
      .get(`/api/users/profile/getUserSignature/${id}?date=${date}`)
      .then((response) => response.data)
      .catch((e) => {
        return Promise.reject(false);
      });
  },

  uploadUserSignature: ({ formData }) => {
    if (!formData) {
      return Promise.reject(false);
    }

    return xhrService
      .post(`/api/users/profile/addSignature`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => response.data)
      .catch((e) => {
        return Promise.reject(false);
      });
  },

  useSignature: (type_of_signature) => {
    if (!type_of_signature) {
      return Promise.reject(false);
    }

    const data = {
      type_of_signature,
    };

    return xhrService
      .post(`/api/users/profile/useSignature`, data)
      .then((response) => response.data)
      .catch((e) => {
        return Promise.reject(false);
      });
  },

  deleteSignature: () => {
    return xhrService
      .delete(`/api/users/profile/deleteSignature`)
      .then((response) => response.data)
      .catch((e) => {
        return Promise.reject(false);
      });
  },

  getAutoAccessToProjects: (id, clientId) => {
    return xhrService
      .get(`/api/users/${id}/getAutoAccessToProjects?clientId=${clientId}`)
      .then((res) => res.data);
  },

  sendVerificationCode: (email, method) => {
    return xhrService
      .post('/api/sendVerificationCode', { email, method })
      .then((res) => res.data)
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      });
  },
   
  verifyCode: (email, code, rememberDevice, method) => {
    return xhrService
      .post('/api/verifyCode', { email, code, rememberDevice, method },
        {
          withCredentials: true,
        }

      )
      .then((res) => res.data)
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          return Promise.reject(error.response.data.message);
        }

        return Promise.reject(null);
      });
  },
};

export default userApi;
